import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Tabs,
  Tab,
  Backdrop,
  CircularProgress,
  Typography,
  Pagination,
} from '@mui/material';
import moment from 'moment';
import HttpService from '../../hooks/Https-services';
import { API_ROUTES } from '../../utils/constant';

export default function LeaderShipTable() {
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState(0);
  const itemsPerPage = 10;
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };
  const processApiData = (data: any) => {
    return data.map((item: any) => ({
      isWorking: item?.isWorking || 0,
      userName: item?.name || 'N/A',
      shiftName: item.shift?.shiftName || 'N/A',
      startTime: moment(item.shift?.startTime).format('hh:mm A') || 'N/A',
      endTime: moment(item.shift?.endTime).format('hh:mm A') || 'N/A',
    }));
  };

  const getTableData = React.useCallback(async () => {
    setLoading(true);
    try {
      const query: any = { page: currentPage, limit: itemsPerPage };
      query.roleId = 1;
      query.checkedIn = true;
      const response = await HttpService.get(
        API_ROUTES.allUser + `?${new URLSearchParams(query).toString()}`
      );
      const apiData = response.data.data.list;
      const processedData = processApiData(apiData);
      setTotalPages(response.data.data.totalPages);
      setTotalCount(response.data.data.totalCount);
      setTableData(processedData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    getTableData();
  }, [getTableData]);
  function LeadershipTableContent({ data }: { data: any[] }) {
    return (
      <>
        {' '}
        <TableContainer component={Paper}>
          <Table>
            {/* <TableHead>
          <TableRow>
            <TableCell>User Name</TableCell>
            <TableCell>Shift Name</TableCell>
            <TableCell>Start Time</TableCell>
            <TableCell>End Time</TableCell>
          </TableRow>
        </TableHead> */}
            <TableBody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'center',
                        }}
                      >
                        {row?.isWorking === 1 && (
                          <Box
                            sx={{
                              height: '15px',
                              width: '15px',
                              borderRadius: '15px',
                              color: 'lightgreen',
                              backgroundColor: 'lightgreen',
                            }}
                          ></Box>
                        )}
                        {row?.userName}
                      </Box>
                    </TableCell>

                    {/* <TableCell>{row.shiftName}</TableCell> */}
                    {/* <TableCell>{row.startTime}</TableCell> */}
                    {/* <TableCell>{row.endTime}</TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>
                    {' '}
                    {/* Adjust colSpan based on the number of columns */}
                    <Typography>No Data</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </TableContainer>
        {/* Pagination Component */}
        <Box display="flex" justifyContent="center" my={2}>
          <Pagination
            count={totalPages} // Total number of pages
            page={currentPage} // Current page
            onChange={handlePageChange} // Handle page change
            color="primary"
          />
        </Box>
      </>
    );
  }

  return (
    <>
      <LeadershipTableContent data={tableData} />
    </>
  );
}
